import { Pipe } from '@angular/core';
import { isNumberFinite } from '../utils/utils';
var DegreesPipe = (function () {
    function DegreesPipe() {
    }
    DegreesPipe.prototype.transform = function (input) {
        if (!isNumberFinite(input)) {
            return 'NaN';
        }
        return (input * 180) / Math.PI;
    };
    return DegreesPipe;
}());
export { DegreesPipe };
DegreesPipe.decorators = [
    { type: Pipe, args: [{
                name: 'degrees'
            },] },
];
/** @nocollapse */
DegreesPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=degrees.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/math/degrees.pipe.js
// module id = 261
// module chunks = 103